import React from "react";
import {
  SiGithub,
  SiInstagram,
  SiWhatsapp,
  SiTelegram,
  SiYoutube,
  SiDiscord,
} from "react-icons/si";

export default function ColorfulSocialCards() {
  const socials = [
    {
      name: "GitHub",
      icon: SiGithub,
      link: "#",
      color: "text-gray-900 dark:text-white",
      bg: "hover:bg-gray-900/10 dark:hover:bg-gray-100/10",
      border: "hover:border-gray-500",
    },
    {
      name: "Instagram",
      icon: SiInstagram,
      link: "#",
      color: "text-pink-600",
      bg: "hover:bg-pink-500/10",
      border: "hover:border-pink-500",
    },
    {
      name: "WhatsApp",
      icon: SiWhatsapp,
      link: "#",
      color: "text-green-500",
      bg: "hover:bg-green-500/10",
      border: "hover:border-green-500",
    },
    {
      name: "Telegram",
      icon: SiTelegram,
      link: "#",
      color: "text-blue-500",
      bg: "hover:bg-blue-500/10",
      border: "hover:border-blue-500",
    },
    {
      name: "YouTube",
      icon: SiYoutube,
      link: "#",
      color: "text-red-600",
      bg: "hover:bg-red-500/10",
      border: "hover:border-red-500",
    },
    {
      name: "Discord",
      icon: SiDiscord,
      link: "#",
      color: "text-indigo-500",
      bg: "hover:bg-indigo-500/10",
      border: "hover:border-indigo-500",
    },
  ];

  return (
    <section className="relative py-16 px-6 lg:px-16 overflow-hidden bg-[#fbfbfb] dark:bg-[#050505] transition-colors duration-300">
      {/* Background Glows - Adjusted opacity for both modes */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-blue-500/5 blur-[140px] rounded-full pointer-events-none" />

      {/* Grid Pattern - Subtler for both modes */}
      <div className="absolute inset-0 opacity-[0.03] dark:opacity-[0.05] bg-[linear-gradient(rgba(0,0,0,1)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,1)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,1)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,1)_1px,transparent_1px)] bg-[size:60px_60px]" />

      <div className="relative z-10 max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-black text-gray-900 dark:text-white mb-6 text-center">
          Connect with Our
          <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
            {" "}
            Commuinity
          </span>
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {socials.map((social, index) => (
            <a
              key={index}
              href={social.link}
              className={`group flex flex-col items-center justify-center p-4 bg-white dark:bg-[#0f0f0f] rounded-lg border border-gray-200 dark:border-gray-800 transition-all duration-500 hover:scale-105 ${social.bg} ${social.border}`}
            >
              <div
                className={`${social.color} transition-all duration-500 group-hover:scale-110`}
              >
                <social.icon size={30} />
              </div>
              <span className="mt-4 text-sm font-bold text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-white">
                {social.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
